export default function BreadcrumbItem({ children,isActive }) {
    return <>
        <div className={isActive? "breadcrumb-item active":"breadcrumb-item"}>
            {children}
        </div></>;
}
